let datasource = {}

/**
 *10:提案計画登録中13:提案計画変更中30:提案計画活動中
33:提案計画未採用32:受注34:受注キャンセル40:納品完了
 */
//区分マスタ
datasource['divisionList'] = require('./divisions/list/index')

// todo 発注書コメント定型文apiの提供必要
datasource['fixedDocList'] = [
  {
    mode: '1',
    name: '※上記の納期内でご調整の上、1週間以内に工事予定連絡FAXを送りください。日程調整がつかない場合は、お手数ですがお電話にてお知らせください。',
  },
  {
    mode: '2',
    name: '※上記の納期内でご調整の上、1週間以内に工事予定連絡FAXを送りください。日程調整がつかない場合は、お手数ですがお電話にてお知らせください。',
  },
]

//todo 発注書出力日apiの提供必要
datasource['orderList'] = [
  {
    mode: '1',
    name: '建築業法　　+納品報告',
  },
  {
    mode: 'E',
    name: '建築業法1　　+納品報告1',
  },
]
datasource['tzList'] = [
  {
    mode: '01',
    name: 'あり',
  },
  {
    mode: '02',
    name: 'なし',
  },
]
//進行部門
datasource['jxbmconst'] = [
  {
    value: '1',
    label: '工事部',
  },
]
export default datasource
